import React from "react";
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import {
  Typography, Slider, IconButton,useTheme
} from '@mui/material';
import {
  AddCircle, RemoveCircle, HelpRounded
} from '@mui/icons-material';
import Parser from 'html-react-parser';

import { GenericContainer, InputField, CustomAlertHelpDialog, Alert, CustomLoadingOverlay ,Buttons } from '../../components'
import { useStyles } from "./CreditSimulatorStyles";
//import { mainStyles, theme } from "../../styles/Main.js";
import { authActions, workflowActions, creditActions } from "../../store/actions";
import { getHash,coreFunctions } from '../../utils'
import { useTranslation } from "react-i18next";

const formatterDolar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
})

export default function CreditSimulatorComponent(props) {
  const { useState, useEffect } = React;

  const localStyles = useStyles();
  const gridContainer = {} //mainStyles.gridStyle();
  const navigate = useNavigate();
   const theme = useTheme()
    const location = useLocation()
  const classes = {} //mainStyles.bodyStyles();

  const [value, setValue] = useState(1000);
  const [fileId, setFileId] = useState(0)
  const [activeInitial, setActiveInitial] = useState(false)
  const [calculatorOptions, setCalculatorOptions] = useState([])
  const [formChange, setFormChange] = useState(false)
  const [WFChange, setWFChange] = useState(false)

  const [itemMonth, setItemMonth] = useState({})
  const [maxSlider, setMaxSlider] = useState(203000)
  const [maxAmount, setMaxAmount] = useState('')
  // const [minMonth, setMinMonth] = useState(0)
  // const [minMonthText, setMinMonthText] = useState('')
  // const [maxMonth, setMaxMonth] = useState(0)
  // const [maxMonthText, setMaxMonthText] = useState('')
  const [plazo, setPlazo] = useState('')
  const [tasaAnual, setTasaAnual] = useState('0%')
  const [tasaAnualIva, setTasaAnualIva] = useState('0%')
  const [tasaMensual, setTasaMensual] = useState('0%')
  const [tasaMensualIva, setTasaMensualIva] = useState('0%')
  const [cat, setCat] = useState('0%')
  const [pagoMensual, setPagoMensual] = useState('')
  const [loadView, setLoadView] = useState(false);

  const [title, setTitle] = useState("");
  const [open, setOpen] = useState(false);

  const [optionsDependencies, setOptionsDependencies] = useState([])
  const [optionsPlazos, setOptionsPlazos] = useState([])

  const [namePlazo, setNamePlazo] = useState("meses")
  const [dependenceCurrent, setDependenceCurrent] = useState("")
  const [plazoCurrent, setPlazoCurrent] = useState("")
  const [listItemsPlazos, setListItemsPlazos] = useState([])
  const [minSlider, setMinSlider] = useState(1000)
  const [saltoSlaider, setSaltoSlaider] = useState(1000)
  const [plazoNombreCalculate, setPlazoNombreCalculate] = useState("mensual")
  const [activeDependencies, setActiveDependencies] = useState(false)


  //Redux hooks 
  const wf = useSelector(state => state.Workflow)
  const auth = useSelector(state => state.Authentication)
  const dependencData = useSelector(state => state.DependenciesData)
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    // sessionStorage.setItem('token', "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InVzcmFnZW50ZTEiLCJuYW1laWQiOiIxNDkiLCJuYmYiOjE2NjAyNDAyMDksImV4cCI6MTY2MDMyNjYwOSwiaWF0IjoxNjYwMjQwMjA5LCJpc3MiOiJBdXRlbnRpY2FjaW9uT25Cb2FyZGluZ1NlcnZpY2UiLCJhdWQiOiJEZWZhdWx0QXVkaWVuY2UifQ.1xaRILQfU08Ya4T9_7vc7W9Yxc1RxQcBOaqv8RNDbgc")
    sessionStorage.setItem('token', "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InVzcmFnZW50ZTEiLCJuYW1laWQiOiIxNDkiLCJuYmYiOjE2NjA1ODY4NDcsImV4cCI6MTk3NTk0Njg0NywiaWF0IjoxNjYwNTg2ODQ3LCJpc3MiOiJBdXRlbnRpY2FjaW9uT25Cb2FyZGluZ1NlcnZpY2UiLCJhdWQiOiJEZWZhdWx0QXVkaWVuY2UifQ.zkgeYY2lnSAp4OuGvD4RCEmDiCKrRmNkRmOH841jaf8")
    let wfData = {
      Workflow_Id: 0,
      Workflow_Version: 0,
      // Apk_Version: "1.0.19",
      Apk_Version: "1.1.1",
      IMEI: "PWA"
    }
    dispatch(workflowActions.GetWorkflowDefinitions(wfData))
    setWFChange(true)

    setLoadView(true)
    setTitle("Calculadora")
    dispatch(creditActions.GetDependencies(""))
    setActiveDependencies(true)
  }, []);

  useEffect(() => {
    if (wf.items != undefined && dependencData.items != undefined && WFChange) {
      setWFChange(false)
      setLoadView(false)
      // setMaxSlider(406000)
      // setMaxAmount('$406,000')

      let stageCurrent = wf.items[0].Stages.find(items => items.Name == "Dashboard")
      let optionsValues = stageCurrent.Properties.find(item => item.Name == "CalculatorOptions")
      let optionsArray = JSON.parse(optionsValues.Value);
      let orderArray = optionsArray.sort((a, b) => a.Plazo - b.Plazo)

      let arregloDefault = orderArray[0];
      // console.log("arregloDefault: ", arregloDefault)
      let objVale = {
        index: 0,
        Name: arregloDefault.Name,
        TasaAnual: arregloDefault.TasaAnual,
        TasaMensual: arregloDefault.TasaMensual,
        CAT: arregloDefault.CAT,
        Plazo: plazoCurrent
      }

      setItemMonth(objVale)
      operationsCalculate(objVale, value)

    } else if (wf.error != undefined && WFChange) {
      setLoadView(false)
      Alert({
        icon: "error",
        text: 'Error: ' + wf.error,
        okbtntext: t("general_accept"),
      });
      setWFChange(false)
    }
  }, [wf.items])

  useEffect(() => {
    if (formChange) {
      operationsCalculate(calculatorOptions, value)
      if (location.state?.selectEdit != undefined && location.state?.selectEdit != null) {
        let monto = location.state.selectEdit.monto.replace('$', '')
        setValue(monto)
        operationsCalculate(itemMonth, monto)
      }
    }
  }, [calculatorOptions])

  useEffect(() => {
    if (dependencData.options != undefined && activeDependencies) {
      setActiveDependencies(false)
      setOptionsDependencies(dependencData.options)

      let ListOptions = dependencData.formatData[0]
      setDependenceCurrent(ListOptions.Value)
      console.log("ListOptions******Default", ListOptions)
      setPlazoCurrent(ListOptions.PlazosList[0]?.value)
      setValue(ListOptions.LimiteInferior)

      setMaxSlider(ListOptions.LimiteSuperior)
      setMaxAmount(`${ListOptions.LimiteSuperior}`)
      setMinSlider(ListOptions.LimiteInferior)
      setOptionsPlazos(ListOptions.PlazosList)
      setNamePlazo(ListOptions.PlazoNombre)
      setSaltoSlaider(ListOptions.Saltos)

    } else if (dependencData.error != undefined && activeDependencies) {
      setActiveDependencies(false)
      setLoadView(false)
      Alert({
        icon: "error",
        text: dependencData.error,
        okbtntext: t("general_accept"),
      });
    }
  }, [dependencData])

  let operationsCalculate = (itemValue, valueAmount, plazoValue = plazoCurrent) => {
    let iva = 1.16
    // Tasa Anual
    setTasaAnual(`${itemValue.TasaAnual?.toFixed(2)}%`)
    // Tasa Anual con IVA
    let tasaAnualIva = itemValue.TasaAnual * iva
    setTasaAnualIva(`${tasaAnualIva?.toFixed(2)}%`)
    // Tasa Mensual
    setTasaMensual(`${itemValue.TasaMensual?.toFixed(2)}%`)
    // Tasa Mensual con IVA
    let tasaMensualIva = itemValue.TasaMensual * iva
    setTasaMensualIva(`${tasaMensualIva?.toFixed(2)}%`)
    // CAT
    setCat(`${itemValue.CAT}%`)
    // Pago mensual
    let rawAmount = valueAmount
    // console.log("rawAmount: monto itemValue.Plazo--------value ", itemValue.Plazo)
    let termRaw = (plazoValue === undefined ? 18 : plazoValue)
    let annualRateRaw = itemValue.TasaAnual
    let annualRateWhitIVA = tasaAnualIva
    let monthlyInterest = (annualRateWhitIVA / (12 * 100))
    let monthlyPayment = rawAmount * monthlyInterest / (1 - Math.pow(1 + monthlyInterest, (termRaw * -1))) - 0.242

    // console.log("monthlyPayment: monto value", monthlyPayment)
    setPagoMensual(monthlyPayment?.toFixed(2))

    let objVale = {
      Name: itemValue.Name,
      Plazo: plazoValue,
      TasaAnual: itemValue.TasaAnual,
      TasaMensual: itemValue.TasaMensual,
      CAT: itemValue.CAT,
      PagoMensual: monthlyPayment,
      IsCalculator: "true",
      Monto: valueAmount
    }
    // console.log("objVale ", objVale)
    setItemMonth(objVale)
  }

  let handleInputChange = (event) => {
    // console.log("eventChange: ", event)
    if (event.target.value > maxSlider) {
      setValue(minSlider)
      Alert({
        icon: "error",
        text: "El monto ingresado es mayor al permitido, por favor ingresa un monto menor para continuar.",
        okbtntext: t("general_accept"),
      });
      operationsCalculate(itemMonth, minSlider)
    } else if (event.target.value < 0) {
      setValue(minSlider)      
      Alert({
        icon: "error",
        text: "El monto ingresado es menor al permitido, por favor ingresa un monto mayor para continuar.",
        okbtntext: t("general_accept"),
      });
      operationsCalculate(itemMonth, minSlider)
    } else {
      setValue(event.target.value === '' ? 0 : Number(event.target.value));
      operationsCalculate(itemMonth, event.target.value)
    }
  };

  let removeAmount = () => {
    // console.log("Valor add - : ", value)
    if (value != 1000) {
      if (value > 999) {
        // console.log("Remove value: ", value)
        setValue(value - saltoSlaider)
        operationsCalculate(itemMonth, value - saltoSlaider)
      }
    }
  }

  let addAmount = () => {
    if (maxSlider > value) {
      setValue(value + saltoSlaider)
      operationsCalculate(itemMonth, value + saltoSlaider)
    }
  }

  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
    operationsCalculate(itemMonth, newValue)
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  let handleBackCalculator = (e) => {
    sessionStorage.removeItem('token');
    window.location.href = `${process.env.PUBLIC_URL}`;
  }

  let handleCredithOffer = (e) => {
    let isRegister = true
    let nextComponent = "RegisterComponent"
    coreFunctions.DoNextStage({ navigate,nextComponent, State: { isRegister} })
  }

  let handleCmbSelect = (event) => {
    console.log("eventChange ---: ", event.target)
    setDependenceCurrent(event.target.value)
    let ListOptions = dependencData.formatData?.find(item => item.Value === event.target.value)
    setPlazoCurrent(ListOptions.PlazosList[0]?.value)
    LlenadoInformacion(ListOptions)
    operationsCalculate(itemMonth, value, ListOptions.PlazosList[0]?.value)
  };

  let handleCmbPlazoSelect = (event) => {
    console.log("handleCmbPlazoSelect ---: ", event.target)
    setPlazoCurrent(event.target.value)
    let ListOptions = dependencData.formatData?.find(item => item.Value === dependenceCurrent)
    LlenadoInformacion(ListOptions)
    operationsCalculate(itemMonth, value, event.target.value)
  };

  let LlenadoInformacion = (ListOptions) => {
    // console.log("eventChange ---: ", event.target)
    setMaxSlider(ListOptions.LimiteSuperior)
    setMaxAmount(`${ListOptions.LimiteSuperior}`)
    setMinSlider(ListOptions.LimiteInferior)
    setOptionsPlazos(ListOptions.PlazosList)
    setNamePlazo(ListOptions.PlazoNombre)
    setSaltoSlaider(ListOptions.Saltos)
    setPlazoNombreCalculate(ListOptions.PlazoNombreCalculate)
  };

  return (<GenericContainer>
        <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
       
       
          <Typography variant="h6"
            gutterBottom
            
          >{title}
            <HelpRounded
              className={localStyles.helpIcon}
              onClick={handleClickOpen}
            />
          </Typography>

          <InputField
            // className={fieldStyles.root}
            id="cmbDependencies"
            name="cmbDependencies"
            label="Dependencias"
            variant='outlined'
            tabIndex={0}
            onChange={handleCmbSelect}
            formControlClassName={localStyles.formControl}
            formLabelClassName={localStyles.formLabel}
            required
            value={dependenceCurrent}
            size="small"
            type="Combo"
            Options={optionsDependencies}
          />

          <Typography variant="subtitle1"
            gutterBottom
            className={localStyles.subTitleCalculate}>Monto de crédito</Typography>

          <div className={localStyles.container}>
            <div className={localStyles.leftColumn}>
              <IconButton
                color="primary"
                aria-label="remove"
                component="span"
                onClick={removeAmount}>
                <RemoveCircle />
              </IconButton>
            </div>
            <div className={localStyles.centerColumn}>
              <InputField
                id="txtMonto"
                name="txtMonto"
                label=""
                value={value}
                className={localStyles.inputAmount}
                onChange={handleInputChange}
                size={26}
                underline={localStyles.underline}
                type='Moneda'
              />
            </div>
            <div className={localStyles.rightColumn}>
              <IconButton
                color="primary"
                aria-label="add"
                component="span"
                onClick={addAmount}>
                <AddCircle />
              </IconButton>
            </div>
          </div>

          <Slider
            value={typeof value === 'number' ? value : 0}
            aria-label="custom thumb label"
            color="primary"
            step={saltoSlaider}
            min={minSlider}
            max={maxSlider}
            onChange={handleSliderChange} />
          <div className={localStyles.container}>
            <div className={localStyles.leftColumn}>
              <Typography
                variant="subtitle1"
                gutterBottom
                className={localStyles.balanceText}>{`$${minSlider}`}</Typography>
            </div>
            <div className={localStyles.centerColumn}>
            </div>
            <div className={localStyles.rightColumn}>
              <Typography
                variant="subtitle1"
                gutterBottom
                className={localStyles.balanceText}>{`$${maxAmount}`}</Typography>
            </div>
          </div>
          <Typography variant="subtitle1"
            gutterBottom
            className={localStyles.subTitleCalculate}>Plazo</Typography>
          {/* <Typography
            variant="subtitle1"
            gutterBottom
            className={localStyles.titleSmall}>{plazo} </Typography> */}

          <InputField
            // className={fieldStyles.root}
            id="cmbPlazos"
            name="cmbPlazos"
            label="Plazos"
            variant='outlined'
            onChange={handleCmbPlazoSelect}
            formControlClassName={localStyles.formControl}
            formLabelClassName={localStyles.formLabel}
            required
            value={plazoCurrent}
            size="small"
            type="Combo"
            Options={optionsPlazos}
          />

          <Typography variant="subtitle1"
            gutterBottom
            className={localStyles.subTitleCalculate}>{`Pago ${plazoNombreCalculate}`}</Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            className={localStyles.titleSmall}>{formatterDolar.format(pagoMensual)}</Typography>
          <div className={localStyles.containerResult}>
            <div className={localStyles.leftColumnResult}>
              <Typography
                variant="subtitle1"
                gutterBottom
                className={localStyles.calculatesText}>{"Tasa anual"}</Typography>
              <Typography
                variant="subtitle1"
                gutterBottom
                className={localStyles.calculatesText}>{"Tasa anual con IVA"}</Typography>
              <Typography
                variant="subtitle1"
                gutterBottom
                className={localStyles.calculatesText}>{"Tasa mensual"}</Typography>
              <Typography
                variant="subtitle1"
                gutterBottom
                className={localStyles.calculatesText}>{"Tasa mensual con IVA"}</Typography>
              <Typography
                variant="subtitle1"
                gutterBottom
                className={localStyles.calculatesText}>{"CAT"}</Typography>
            </div>
            <div className={localStyles.rightColumnResult}>
              <Typography
                variant="subtitle1"
                gutterBottom
                className={localStyles.calculatesText}>{tasaAnual}</Typography>
              <Typography
                variant="subtitle1"
                gutterBottom
                className={localStyles.calculatesText}>{tasaAnualIva}</Typography>
              <Typography
                variant="subtitle1"
                gutterBottom
                className={localStyles.calculatesText}>{tasaMensual}</Typography>
              <Typography
                variant="subtitle1"
                gutterBottom
                className={localStyles.calculatesText}>{tasaMensualIva}</Typography>
              <Typography
                variant="subtitle1"
                gutterBottom
                className={localStyles.calculatesText}>{cat}</Typography>
            </div>
          </div>
          <Buttons
            ConfirmButtonText="Solicitar crédito"
            onClickConfirm={handleCredithOffer}
            CancelButtonText={t("general_cancel")}
            onClickCancel={handleBackCalculator}
          />

          <CustomAlertHelpDialog open={open}
            closeAction={handleClose}
            title="¿Cómo se calculan las comisiones?"
            body={
              <div>
                <Typography gutterBottom className={localStyles.instructions} >{Parser("<b>Tasa anual.</b>")}</Typography>
                <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>{Parser("Es la tasa que se cobra por los préstamos o las ganancias obtenidas a través de una inversión, y se expresa como un porcentaje que representa el costo anual real de los fondos durante el plazo de un préstamo. <br> Esto incluye cualquier cargo o costo adicional asociado con la transacción pero no toma en cuenta la capitalización.")}</Typography>
                <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>{Parser("<b>¿Cómo se calcula la Tasa Anual de un préstamo?</b>")}</Typography>
                <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>{Parser("Para calcular la tasa efectiva anual de un préstamo es necesario conocer el valor neto del préstamo solicitado, la tasa de interés establecida por la entidad financiera o prestamista y el plazo en que el mismo debe ser cancelado <br> Una vez determinadas estas tres variables, se utiliza una fórmula para determinar el valor de cada cuota mensual. <br> Sería: EAR = 1 + inn –1EAR = Tasa de interés efectiva anuali = Tasa de interés nominaln = cantidad de pagos consecutivos cancelados en un añoPasos para calcular la tasa efectiva anual de un préstamo.")}</Typography>
                <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>1.En primer lugar se divide la tasa de interés nominal entre 100 para convertirlo en número natural.</Typography>
                <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>2.Entonces se divide el resultado entre la cantidad de pagos a realizar en el año, es decir, si es pago mensual seríandividido entre 12, si es pago semestral sería dividido entre 2, etc.</Typography>
                <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>3.Se le suma una unidad al resultado (+1)</Typography>
                <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>4.El resultado se eleva a la potencia de n (pagos a realizar anualmente).</Typography>
                <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>{Parser("5. Por último se resta una unidad (-1) y este será el valor de latasa efectiva de interés anual de un préstamo.<br>Ejemplo:<br> 1.Tenemos una tasa de interés nominal del 15% (15/100 = 0,15), cuyo préstamo debe ser pagado en cuotas trimestrales.")}</Typography>
                <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>2.EAR = 0,15/4 (número de trimestres en el año) = 0,0375 + 1 = 1,03753. EAR = 1,0375^4 = 1,1586 –1 = 0,1586</Typography>
              </div>
            }
          />
    </GenericContainer>);
}
